import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Col, Row } from "reactstrap";

//Components
import Loading from "../../../components/Loading/Loading";
import MainCard from "../../../components/MainCard/MainCard";
 
import { showMessage } from "../../../helpers/message";
 
//Api
import relatorio_api from "../../../api/relatorio_api";
import RelatorioGeradoresSemContratoFirmado from "./RelatorioGeradoresSemContratoFirmado";
import FiltroPrefeitura from "views/Shared/FiltroPrefeitura"; 

function initialStateFiltros() {
  return {
    cpfcnpj: "",
    prefeitura_Id: "",
    nomeRelatorio: "Relatórios - Geradores sem contrato firmado",
  };
}

export default function GeradoresSemContratoFirmado() {
  //Variavel utilizada para navegação
  const navigate = useNavigate();

  //Estado de controle do loading na tela
  const [loading, setLoading] = useState(false);

  //Estado de controle dos valores dos filtros
  const [filtros, setFiltros] = useState(initialStateFiltros());

  //Estado que guarda os dados do relatorio
  const [dadosRelatorio, setDadosRelatorio] = useState([]);

  const [prefeitura_Id, setPrefeitura_Id] = useState(null);

  //Função que puxa os dados do relatorio
  const carregarRelatorio = (prefeitura_Id) => {
    let _filtros = {};

    _filtros = {
      ...filtros,
      prefeitura_Id,
    };

    setLoading(true);
    relatorio_api
      .RelatorioGeradoresSemContratoFirmado(_filtros)
      .then((response) => {
        setFiltros({
          ...filtros,
        });
        setDadosRelatorio(response.data);
      })
      .catch((e) => showMessage("Aviso", e.message, "error", null))
      .finally((f) => setLoading(false));
  };

  const handlePrefeitura = (value) => {
    setPrefeitura_Id(value);
    carregarRelatorio(value);
  };

  if (dadosRelatorio.length > 0) {
    return (
      <RelatorioGeradoresSemContratoFirmado
        dadosRelatorio={dadosRelatorio}
        btnVoltar={() => {
          setDadosRelatorio([]);
          carregarRelatorio(prefeitura_Id);
        }}
        filtros={filtros}
      />
    );
  }

  return (
    <MainCard btnVoltarInTop={() => navigate(-1)}>
      {loading && <Loading />}
      <FiltroPrefeitura handleValue={handlePrefeitura}></FiltroPrefeitura>
    </MainCard>
  );
}
